import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  NotificationTemplateFilters,
  NotificationTemplateSlice,
} from "./notificationTemplatesTypes.ts";

const initialState: NotificationTemplateSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const notificationTemplatesSlice = createSlice({
  name: "notificationTemplates",
  initialState,
  reducers: {
    setPage: (
      state,
      action: PayloadAction<NotificationTemplateSlice["page"]>,
    ) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<NotificationTemplateSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [
          filterType: keyof NotificationTemplateFilters,
          filterValue: string | undefined,
        ]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (
      state,
      action: PayloadAction<NotificationTemplateSlice["sort"]>,
    ) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  notificationTemplatesSlice.actions;

export const selectPage = (state: RootState) =>
  state.notificationTemplates.page;
export const selectRowsPerPage = (state: RootState) =>
  state.notificationTemplates.rowsPerPage;
export const selectFilter = (state: RootState) =>
  state.notificationTemplates.filter;
export const selectSort = (state: RootState) =>
  state.notificationTemplates.sort;

export default notificationTemplatesSlice.reducer;
